import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ActiveInlineEditorState {
  activeWidgetId: number | string | null
}

const initialState: ActiveInlineEditorState = {
  activeWidgetId: null,
}

const activeInlineEditorSlice = createSlice({
  name: 'activeInlineComparisonEditor',
  initialState,
  reducers: {
    setActiveInlineEditor: (state, action: PayloadAction<number | string>) => {
      state.activeWidgetId = action.payload
    },
    clearActiveInlineEditor: (state, action: PayloadAction<number | string | undefined>) => {
      if (action.payload === undefined || state.activeWidgetId === action.payload) {
        state.activeWidgetId = null
      }
    },
  },
})

export const { setActiveInlineEditor, clearActiveInlineEditor } = activeInlineEditorSlice.actions
export const activeInlineEditorState = (state: any) => state.activeInlineComparisonEditor

export default activeInlineEditorSlice.reducer
